import { graphql, useStaticQuery } from 'gatsby'
import { TransformedStory } from 'theme/atoms/Story'

type Result = {
  story: TransformedStory
  contentfulID: string
  description: string
  title: string
}

export default function use404StaticBlock(): Result {
  const query = useStaticQuery(graphql`
    query NotFoundBlock {
      staticBlock(identifier: { eq: "404" }) {
        story
        contentfulID
        description
        title
      }
    }
  `)
  return query.staticBlock
}
